import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";

import { Divider } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    //maxWidth: '90%',
    width: "100%",
    height: "95%",
    margin: "0 auto",
    // marginBottom:'4rem',
    //height:'100%'
  },
  content: {},
}));

export default function ChartsCard({ title, content }) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardHeader
        title={title}
        subheader={`Uads elections will hold tentatively on the 26th of July`}
      />
      <Divider />
      <CardContent className={classes.content}>{content}</CardContent>
    </Card>
  );
}
